export const displayMax = (value, max = 9) => (parseInt(value || 0) || 0) > max ? `${max}+` : value